import { ModalMediumCentered } from '../../../../../../baseComponents/Modal'
import TwinTrans from '../../../../../../baseComponents/TwinTrans'
import { ButtonDisabledOrLoader, ButtonSecondary } from '../../../../../../baseComponents/Button'
import { WorkSheetModelAdd } from '@teinor/erp/types/company/order/sell/workSheet'
import { FormRender } from '../../../../../../forms/FormRenderer/types'
import TwinForm from '../../../../../../forms/TwinForm'
import FormRenderer from '../../../../../../forms/FormRenderer'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import { dictionaryComplexFromJsonArr } from '../../../../../../utils/globals/dictionary'
import { AllReduxPayloads } from '../../../../../../utils/reducers'
import { connect, ConnectedProps } from 'react-redux'
import withLoading from '../../../../../../utils/hoc/withLoading'
import { WorkSheetGroupStatusesPayload } from '../../../../../../utils/reducers/sells/workSheetGroupStatus'
import { useCallback, useMemo } from 'react'
import { BeforeSubmitHandler, OnSubmit } from '../../../../../../forms/TwinForm/types'
import { OrderData } from '../../../OrderLayout/types'
import { parseSelectedTableWorkSheetForProcessingByType } from '../../../../../../app/erp/screens/Logistic/QuoteParent/SellParent/functions'
import { useNavigate } from 'react-router'
import locations from '../../../../../../utils/globals/locations'
import { SetEditDeleteModalTy } from '../../../../../../utils/hooks/useEditDeleteModal'
import { getConfigParam } from '../../../../../../utils/reducers/getters'
import useOrderTypeSelectProductsDict from '../../../../../../utils/hooks/orders/useOrderTypeSelectProductsDict'
import useIsLoading from '../../../../../../utils/hooks/useIsLoading'

type ModalCreateWorkSheetProps = ReduxWorkSheetGroupStatus & ModalCreateWorkSheetLogicProps & {
    orderField: 'SellOrderId' | 'SellDeliveryNoteId' | 'SellInvoiceId'
    createURL: string
    OrderId: number
}
interface WorkSheetModelAddExtended extends WorkSheetModelAdd {
    type: string
}
const ModalCreateWorkSheet: React.FC<ModalCreateWorkSheetProps> = ({ orderField, OrderId, workSheetGroupStatuses, createURL, ...logic }) => {
    const { t } = useTwinTranslation()
    const { handleBeforeSubmit, handleonSubmit, loading} = useModalCreateWorkSheetLogic({ ...logic })
    const memoDefaultWorkSheetType = useMemo(() => getConfigParam('workSheetTypeByDefault'), [])
    const dictCreateType = useOrderTypeSelectProductsDict()
    const myStatusGroups = dictionaryComplexFromJsonArr(workSheetGroupStatuses?.WorkSheetActiveStatusGroups || [])
    const fields: FormRender<WorkSheetModelAddExtended> = [
        {
            cols: 1,
            elements: [
                {
                    name: 'type',
                    component: 'CustomSelect',
                    label: t('create', 'Crear'),
                    items: dictCreateType || {},
                    value: memoDefaultWorkSheetType || 'allProducts'
                },
                {
                    name: 'WorkSheetGroupStatusId',
                    component: 'CustomSelectWithSearchBar',
                    label: t('statusGroup', 'Grupo de estados'),
                    items: myStatusGroups,
                    value: workSheetGroupStatuses?.WorkSheetActiveStatusGroups?.[0]?.id || ''
                },
                {
                    name: orderField,
                    component: 'InputHidden',
                    value: OrderId
                },
            ]
        }
    ]
    return (
        <ModalMediumCentered opened={true} setOpened={() => logic.setOpenModal(null)} className='modal_create_worksheet'>
            <h4 className='text-center'><TwinTrans transKey={'createWorkSheet'}>Crear hoja de trabajo</TwinTrans></h4>
            <TwinForm action={createURL} onSubmit={handleonSubmit} className='mt-20' beforeSubmitHandler={handleBeforeSubmit}>
                <FormRenderer sections={fields} />
                <ButtonDisabledOrLoader textButton={t('accept', 'Acceptar')} buttonIsDisabled={false} className='mx-auto mt-40 w-full' loading={loading} />
                <ButtonSecondary className='mt-10 w-full' onClick={() => logic.setOpenModal(null)}>
                    <TwinTrans transKey='back'>Volver</TwinTrans>
                </ButtonSecondary>
            </TwinForm>
        </ModalMediumCentered>
    )
}

interface ModalCreateWorkSheetLogicProps {
    completeData: OrderData
    setOpenModal: SetEditDeleteModalTy
}

const useModalCreateWorkSheetLogic = ({ completeData, setOpenModal }: ModalCreateWorkSheetLogicProps) => {
    const navigate = useNavigate()
    const { startLoading, endLoading, loading } = useIsLoading()
    const handleBeforeSubmit: BeforeSubmitHandler = useCallback((vals) => {
        startLoading?.()
        vals.selectedProducts = parseSelectedTableWorkSheetForProcessingByType(completeData, vals.type)
        return true
    }, [completeData, startLoading])

    const handleonSubmit: OnSubmit = useCallback(async (vals) => {
        const responseJSON = await vals.json()
        setOpenModal(null)
        endLoading?.()
        navigate(locations.workSheetSingle + '/' + responseJSON.id)
        return true
    }, [navigate, setOpenModal, endLoading])
    return { handleBeforeSubmit, handleonSubmit, loading }
}

const workSheetGroupStatusesDispatch = {
    setWorkSheetGroupStatuses: (payload: WorkSheetGroupStatusesPayload) => ({ type: 'CHANGE_WORKSHEETGROUPSTATUSES', payload }),
}

export type ReduxWorkSheetGroupStatus = ConnectedProps<typeof workSheetGroupStatusConnect>
const mapWorkSheetGroupStatusConnector = (state: AllReduxPayloads) => ({ workSheetGroupStatuses: state.workSheetGroupStatuses })
const workSheetGroupStatusConnect = connect(mapWorkSheetGroupStatusConnector, workSheetGroupStatusesDispatch)
const workSheetGroupStatusConnectLoading = withLoading(ModalCreateWorkSheet, [{ fetchUrl: '/api/app/order/sell/workSheet/workSheetGroupStatus/getAllWorkSheetGroupStatusesComplete', propName: 'workSheetGroupStatuses', setFunctionName: 'setWorkSheetGroupStatuses' }])
const ModalCreateWorkSheetConnect = workSheetGroupStatusConnect(workSheetGroupStatusConnectLoading)


export default ModalCreateWorkSheetConnect